module.exports = __webpack_public_path__ + "img/bubble-reading.798c83c4.webp";